
export default function TagFilter({
  globalSelectedTags = [],
  setGlobalSelectedTags,
  allAvailableTags = [],
  themeColor = 'blue', // 'blue', 'purple', 'emerald'
}) {
  const toggleTag = (tag) => {
    setGlobalSelectedTags(prev =>
      prev.includes(tag)
        ? prev.filter(t => t !== tag)
        : [...prev, tag]
    );
  };

  const clearAll = () => setGlobalSelectedTags([]);

  const themeClasses = {
    blue: {
      selected: 'bg-blue-600/20 text-blue-300 border-blue-500 shadow-sm',
      badge: 'text-blue-200 bg-blue-950/60 border-blue-800',
    },
    purple: {
      selected: 'bg-purple-600/20 text-purple-300 border-purple-500 shadow-sm',
      badge: 'text-purple-200 bg-purple-950/60 border-purple-800',
    },
    emerald: {
      selected: 'bg-emerald-600/20 text-emerald-300 border-emerald-500 shadow-sm',
      badge: 'text-emerald-200 bg-emerald-950/60 border-emerald-800',
    }
  }[themeColor] || themeClasses.blue;

  return (
    <div className="space-y-3">
      {/* Selection Badges */}
      {globalSelectedTags.length > 0 && (
        <div className="flex flex-wrap gap-2 animate-in fade-in slide-in-from-top-1 duration-300">
          {globalSelectedTags.map(tag => (
            <span
              key={tag}
              className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold border transition-all ${themeClasses.badge}`}
            >
              #{tag}
              <button
                onClick={() => toggleTag(tag)}
                className="hover:text-white transition-colors p-0.5"
                aria-label={`${tag}を解除`}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </span>
          ))}
          <button
            onClick={clearAll}
            className="text-[10px] font-black text-gray-500 hover:text-gray-300 uppercase tracking-widest px-2 py-1"
          >
            Clear All
          </button>
        </div>
      )}

      {/* Available Tags Scroll */}
      <div className="flex gap-2 overflow-x-auto no-scrollbar -mx-1 px-1">
        <button
          onClick={clearAll}
          className={`flex-shrink-0 text-[10px] font-black rounded-full px-3 py-1.5 border transition-all uppercase tracking-wider ${
            globalSelectedTags.length === 0
              ? themeClasses.selected
              : 'bg-gray-800 text-gray-500 border-gray-700 hover:border-gray-600'
          }`}
        >
          All
        </button>
        {allAvailableTags.map((tag) => (
          <button
            key={tag}
            onClick={() => toggleTag(tag)}
            className={`flex-shrink-0 text-[10px] font-bold rounded-full px-3 py-1.5 border transition-all ${
              globalSelectedTags.includes(tag)
                ? themeClasses.selected
                : 'bg-gray-800 text-gray-400 border-gray-700 hover:border-gray-600'
            }`}
          >
            #{tag}
          </button>
        ))}
      </div>
    </div>
  );
}
